import { FC } from 'react'
import {
  OrderDetailContentContainer,
  OrderDetailContentLeft,
  OrderDetailContentName,
  OrderDetailContentPrice,
  OrderDetailContentQuantity,
} from '../order.styled'
import { OrderDetailContentImageProps } from '../order.types'
import { currencyFormatted } from '@yuno/sdk-web-core/dist/utils/currency-format'
import { useTranslation } from 'react-i18next'

export const OrderDetailContent: FC<OrderDetailContentImageProps> = ({
  name,
  quantity,
  unit_amount,
  currency,
}) => {
  const { t } = useTranslation()

  return (
    <OrderDetailContentContainer>
      <OrderDetailContentLeft>
        <OrderDetailContentName>{name}</OrderDetailContentName>
        <OrderDetailContentQuantity>
          {t('Quantity')}: {quantity}
        </OrderDetailContentQuantity>
      </OrderDetailContentLeft>
      <OrderDetailContentPrice>
        {currencyFormatted(currency, unit_amount ?? '0')}
      </OrderDetailContentPrice>
    </OrderDetailContentContainer>
  )
}
